import z from "zod";

import { DEFAULT_SERVICE_DATE_TIMEZONE } from "@/shared/practice-timezone";
import { zCoding, zStringReq } from "@/utils/zod";

export const EncounterServiceDateDetailsFields = z.object({
  encounterStartDate: z.date({ required_error: "Date is required" }),
  encounterStartTime: zStringReq("Time is required"),
  encounterStartDateTimezone: zCoding(),
});

export type EncounterServiceDateDetailsFieldsType = z.infer<
  typeof EncounterServiceDateDetailsFields
>;

export const DEFAULT_ENCOUNTER_SERVICE_DATE_DETAILS: EncounterServiceDateDetailsFieldsType = {
  encounterStartDate: new Date(),
  encounterStartTime: new Date().toTimeString().slice(0, 5),
  encounterStartDateTimezone: { ...DEFAULT_SERVICE_DATE_TIMEZONE },
};
